export const getReasonFilters = state => state.reason.reasonFilters;

export const getReasonGridSortCriteria = state => state.reason.reasonGridSortCriteria;
